const awsExports={
    Auth:{
        'userPoolId':'ap-south-1_5psREt0yj',
        'userPoolWebClientId':'5j4he35aqisfnmg1dfk1bbqtep'
    }
}
export default awsExports;